export const TRAINING_FORM_NAME = 'trainingForm';
export const TRAINING_ATTACHMENT_TYPE = 'trainingAttachmentType';
export const TRAINING_UPLOAD_ATTACHMENT_FIELD = 'uploadAttachment';
export const TRAINING_ATTACHMENTS_LIST_FIELD = 'attachments';
